import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {DictionaryService, UserService} from "@amlCore/services";
import {IDictItemType} from "@amlCore/interfaces";
import {DossierAccessEnum} from "@amlCore/enums";
import {Subject} from "rxjs";
import {Utils} from "@amlCore/utils";
import {AlertPanelComponent, AlertPanelService} from "@amlCore/components";
import {ActivatedRoute, Router} from "@angular/router";
import {BankServiceService} from "./bankService.service";
import {BankServiceModel} from "../../model/bankService.model";
import {RiskAccessEnum} from "../../../core/enum/riskAccessEnum";

@Component({
  selector: 'app-bankservice',
  templateUrl: './bankService.component.html'
})
export class BankServiceComponent implements OnInit, OnDestroy {
  submitted = false;
  isSaveForm = false; // Признак, что форма сохранена
  isLoaded = false; // Признак, что форма загружена
  isEdit = false; // Признак, что форма редактируется
  form: FormGroup;
  $destroy = new Subject();

  constructor(
    protected router: Router,
    protected alertPanelSrv: AlertPanelService,
    protected dictSrv: DictionaryService,
    private _route: ActivatedRoute,
    private bankServiceService: BankServiceService,
    private _userSrv: UserService
  ) {
  }

  @ViewChild('alertObjSave') alertObjToSave: AlertPanelComponent;
  item: BankServiceModel;
  id: string;
  protected bankServiceTypeList: IDictItemType[] = [];
  protected risklevelList: IDictItemType[] = [];

  isReadOnlyAccess = this._userSrv.getAccess(RiskAccessEnum.RISK_SERVICES).readOnly;

  ngOnInit(): void {
    this.bankServiceTypeList = this.dictSrv.getStaticData('bankServiceType');
    this.dictSrv.getRemoteData('risklevel').then((result) => {
      this.risklevelList = result;
    });
    this._route.params.subscribe(params => {
      this.id = params.id;
      if(params.id){
        this.isEdit = true;
        this.loadBankService();
      }
    });
    this.form = this.bankServiceService.getForm();
  }

  ngOnDestroy(): void {
    this.$destroy.next();
    this.$destroy.complete();
  }

  loadBankService(): void {
    this.bankServiceService.getBankServiceById(this.id).subscribe(data => {
      this.updateForm(data);
    });
  }

  updateForm(data?: BankServiceModel): void {
    if (data) {
      this.form.patchValue(data);
      this.item = data;
    }
    if(this.isReadOnlyAccess){
      this.form.disable();
    } else{
      this.form.enable();
      if(data?.type) {
        this.f("type").disable();
      }
    }
  }

  save(): void {
    if (this.form.invalid) {
      this.submitted = true;
      this.alertObjToSave.open(this.alertPanelSrv.getErrorMsg('Необходимо заполнить обязательные поля'));
      return;
    }
    const editableData = Utils.clone(this.form.getRawValue());
    this.bankServiceService.saveBankService(editableData).subscribe(data => {
      this.updateForm(data);
      this.form.markAsPristine();
      this.isSaveForm = true;
      this.alertObjToSave.open(this.alertPanelSrv.getSuccessMsg('Данные сохранены'));
    });
  }

  f(field: string) {
    return this.form.get(field);
  }

}






